import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Consents from '../Consents';
import ContinueButton from '../components/ContinueButton';
import { UserToUpdate, MeetingTypes, UserFields } from '../SignupForm.constants';
import T from '../Locale';
const { FACE_TO_FACE } = MeetingTypes;
const { MEETING_TYPE, SHARING_SCREEN, IS_ADVISOR, ENABLED_DOCUMENTS_AND_TIME_BOOKING } = UserFields;
const ConsentsStep = ({ user, updateUser, onSave, partner, errors }) => {
    let consents = [];
    if (partner.consent) {
        consents = Array.isArray(partner.consent.consents) ? partner.consent.consents : Object.values(partner.consent.consents);
    }
    const consentsToRender = consents.filter(consent => consent.visible.includes('SignupForm')).filter(consent => {
        if (user[ENABLED_DOCUMENTS_AND_TIME_BOOKING]) {
            return !consent.options.some(option => ['8-12', '12-17', '17-21'].includes(option.text));
        }
        return consent;
    });
    const shouldItBeReadByAnAdvisor = () => {
        const byAdvisor = true;
        const byClient = false;
        if (!user[IS_ADVISOR]) {
            return byClient;
        }
        if (partner.isSharedScreenQuestionActive) {
            if (user[SHARING_SCREEN]) {
                return byClient;
            }
            else {
                return byAdvisor;
            }
        }
        if (user[MEETING_TYPE] === FACE_TO_FACE) {
            return byClient;
        }
        return byAdvisor;
    };
    return (_jsxs("div", Object.assign({ className: 'flex flex-col' }, { children: [_jsx("h3", Object.assign({ className: 'w-full text-center tailwind-reset text-3xl font-light' }, { children: T('partner.signup.consent.title') })), _jsx("p", Object.assign({ className: 'text-center text-gray-69 pb-6' }, { children: T(`partner.signup.consent.subtext.${shouldItBeReadByAnAdvisor() ? 'remote' : 'faceToFace'}`) })), consentsToRender.map(consent => (_jsx(Consents, { consent: consent, onChange: handleChangeConsent, error: consent.required && errors[consent.text.replace(/[^a-z]/g, '')], className: 'font-light' }, consent.id))), _jsx("div", Object.assign({ className: 'flex flex-row text-center mt-6' }, { children: _jsx("p", Object.assign({ className: 'text-center font-light pb-6' }, { children: T('partner.signup.consent.retractConsent', { partner: partner.name }) })) })), onSave != null && (_jsx(ContinueButton, { id: 'consents', onClick: onSave }))] })));
    function handleChangeConsent(consentId, value, consentsToAdd, consentsToRemove) {
        const existingConsents = Array.isArray(user.consents) ? user.consents : [];
        const newConsents = existingConsents
            .filter((consent) => consentsToRemove.indexOf(consent) === -1)
            .concat(consentsToAdd);
        updateUser({ [consentId]: value, consents: newConsents }, UserToUpdate.BOTH);
    }
};
ConsentsStep.propTypes = {
    user: PropTypes.object.isRequired,
    updateUser: PropTypes.func.isRequired,
    onSave: PropTypes.func,
    partner: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};
export default ConsentsStep;
